class FostrModalDialog extends HTMLElement {
    
    constructor() {
      super();
    }
  
    static get observedAttributes() {
      return ['open'];
    }
  
    connectedCallback() {
      let secondaryClose = this.querySelector('[name="close-modal-button"]');
      this.querySelector('[name="close-modal"]').addEventListener('click', this.hide.bind(this, false));
      if(secondaryClose !== null) {
        this.querySelector('[name="close-modal-button"]').addEventListener('click', this.hide.bind(this, false));
      }
      this.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') this.hide();
      });
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  
    disconnectedCallback() {
    }
  
    attributeChangedCallback(name, oldVal, newVal) {
    }
  
    adoptedCallback() {
    }
  
    show(opener) {
      if (this.hasAttribute('hidden')) { 
        this.removeAttribute('hidden'); 
        this.offsetLeft;
      }
      this.openedBy = opener;
      this.open = true;
      document.getElementsByTagName('html')[0].classList.add('overflow-hidden');
      fostrTrapFocus(this, this.querySelector('[role="dialog"]'));
      this.revealContent();
    }
  
    hide() {
      this.open = false;
      document.getElementsByTagName('html')[0].classList.remove('overflow-hidden');
      fostrRemoveTrapFocus(this.openedBy);
      this.hideContent();
      document.getElementsByClassName('burger')[0].classList.remove('open');
    }
  
    revealContent() {
      this.querySelector('.fostr-modal__content').classList.add('reveal');
    }
  
    hideContent() {
      this.querySelector('.fostr-modal__content').classList.remove('reveal');
    }
  
  
    get open() {
      return this.hasAttribute('open');
    }
  
    set open(val) {
      if(val) {
        this.setAttribute('open', '');
      }else {
        this.removeAttribute('open');
      }
    }
  
  }
  customElements.define('fostr-modal-dialog', FostrModalDialog);
  
  
  class FostrModalOpener extends HTMLElement {
    
    constructor() {
      super();
  
    }
  
    connectedCallback() {
      const button = this.querySelector('button');
      if (!button) return;
      button.addEventListener('click', () => {
        const modal = document.querySelector(this.getAttribute('data-modal'));
        if (modal) modal.show(button);
        if (modal) button.classList.toggle('open');
      });
    }
  
    disconnectedCallback() {
    }
  
    attributeChangedCallback(name, oldVal, newVal) {
  
    }
  
    adoptedCallback() {
      
    }
  
  }
  customElements.define('fostr-modal-opener', FostrModalOpener);
  class FostrMainMenuOpener extends HTMLElement {
    
    constructor() {
      super();
  
    }
  
    connectedCallback() {
      const button = this.querySelector('button');
      if (!button) return;
      button.addEventListener('click', () => {
        const modal = document.querySelector(this.getAttribute('data-modal'));
        if(button.classList.contains('open')) {
          if (modal) modal.hide(button);
          if (modal) button.classList.remove('open');
        } else  {
          if (modal) modal.show(button);
          if (modal) button.classList.add('open');
        }
      });
    }
  
    disconnectedCallback() {
    }
  
    attributeChangedCallback(name, oldVal, newVal) {
  
    }
  
    adoptedCallback() {
      
    }
  
  }
  customElements.define('fostr-menu-opener', FostrMainMenuOpener);